/**
 * Canonical list of notification kinds the user can choose to include in their
 * daily digest email. Shared between the web profile UI (checkbox labels) and
 * the worker (which kinds are "selectable" — see filtering rules below).
 *
 * Filtering contract (worker `dispatchDigestEmails`):
 *  - If the user never configured `emailNotifications` (undefined) → ALL kinds
 *    are included (a useful digest out of the box).
 *  - If configured (even to an empty array) → only the listed kinds are
 *    included; an empty array means "no digest".
 *  - A notification whose `kind` is NOT in this selectable list is ALWAYS
 *    included (future/unknown kinds never silently vanish from the digest).
 */
export const DIGEST_EMAIL_KINDS = [
  { kind: 'mention', label: '@említések' },
  { kind: 'approval_decision', label: 'Ügyfél döntés érkezett' },
  { kind: 'approval_reminder', label: 'Jóváhagyási emlékeztetők' },
  { kind: 'client_view', label: 'Ügyfél megnyitotta a linket' },
  { kind: 'client_comment', label: 'Ügyfél üzenete' },
  { kind: 'ai_job_failed', label: 'AI futás hiba' },
] as const;

export type DigestEmailKind = (typeof DIGEST_EMAIL_KINDS)[number]['kind'];

/** Just the kind strings — handy for building a Set of selectable kinds. */
export const DIGEST_EMAIL_KIND_VALUES: readonly string[] = DIGEST_EMAIL_KINDS.map((k) => k.kind);
